import React from "react";
import { LockClosedIcon } from "@heroicons/react/outline";

import UserService from "../services/UserService";
import EasyTrans from "../components/bundel/EasyTrans";
import { Button } from "../components/ui";

const ExceptionLoginPage = () => {
  return (
    <section className="flex min-h-[70vh] items-center justify-center bg-fairgray px-4 py-16">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-sm ring-1 ring-gray-900/5 sm:p-10">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-fairblue-50 text-fairblue-500">
          <LockClosedIcon className="h-7 w-7" aria-hidden="true" />
        </div>
        <h1 className="mt-5 text-2xl font-bold tracking-tight text-gray-900">
          <EasyTrans>ErrorHandling.MissingLogin.Header</EasyTrans>
        </h1>
        <p className="mt-2 text-gray-500">
          <EasyTrans>ErrorHandling.MissingLogin.Text</EasyTrans>
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <Button
            variant="primary"
            size="lg"
            fullWidth
            onClick={() => UserService.doLogin()}
          >
            <EasyTrans>ErrorHandling.MissingLogin.standardButton</EasyTrans>
          </Button>
          <Button
            variant="outline"
            size="lg"
            fullWidth
            onClick={() => UserService.doRegister()}
          >
            <EasyTrans>ErrorHandling.MissingLogin.secondButton</EasyTrans>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ExceptionLoginPage;
